export default __webpack_public_path__ + "maps-overview-circle-layer-960-6880adc0707d8fea36f3a11925de8b89.png";